import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 58 41",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 56.561,
		height: 39,
		x: .5,
		y: 1,
		fill: "#fff",
		stroke: "#e4e4e7",
		rx: 3.5
	}), /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#ed0006",
				d: "M29.193 29.095a11.02 11.02 0 0 1-7.28 2.748c-6.197 0-11.222-5.151-11.222-11.505S15.716 8.833 21.914 8.833c2.778 0 5.32 1.035 7.28 2.748a11.02 11.02 0 0 1 7.279-2.748c6.198 0 11.222 5.151 11.222 11.505S42.67 31.843 36.473 31.843c-2.778 0-5.32-1.035-7.28-2.748"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#f9a000",
				d: "M29.191 29.095a11.6 11.6 0 0 0 3.943-8.757 11.6 11.6 0 0 0-3.943-8.757 11.02 11.02 0 0 1 7.28-2.748c6.198 0 11.222 5.151 11.222 11.505S42.67 31.843 36.471 31.843c-2.778 0-5.32-1.035-7.28-2.748"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#ff5e00",
				d: "M29.193 11.581c2.413 2.11 3.943 5.25 3.943 8.757s-1.53 6.646-3.943 8.756c-2.413-2.11-3.943-5.25-3.943-8.756s1.53-6.647 3.943-8.757"
			})
		]
	})]
});
export default SvgMastercard;
